import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

function FormProdcutType(props) {
    const { formik } = props
    return (
        <React.Fragment>
            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Attribute Name"}
                isRequired={true}
                placeholder={"Attribute Name"}
                formikFieldName={"attribute_name"}
            />

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                labelName={"Status"}
                isRequired={true}
                formikFieldName={"status"}
            >
                <option>Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
            </AppFormikSelectInline>

        </React.Fragment>
    )
}


export default memo(FormProdcutType)